export default {
  "Incomes Report": "Rapport revenus",
  Incomes: "Revenus",
  "Add an income": "Enregistrer un revenu",
  Amount: "Montant",
  amount: "montant",
  Status: "Statut",
  status: "statut",
  Date: "Date",
  date: "date",
  Category: "Catégorie",
  category: "catégorie",
  "Reference ID": "ID de référence",
  Actions: "Actions",
  actions: "actions",
  "Create an income": "Créer un revenu",
  "Income category": "Catégorie de revenu",
  Account: "Compte",
  account: "compte",
  Description: "Description",
  description: "description",
  "Income Details": "Détails du revenu",
  "Transaction Details": "Détails de la transaction",
  User: "Utilisateur",
  user: "utilisateur",
  "Reference Id": "ID de référence",
  Reference: "Référence",
  reference: "référence",
  Created: "Créé le",
  "All statuses": "Tous les statuts",
  "All Categories": "Toutes les catégories",
  "Start Date": "Date de début",
  "End date": "Date de fin",
  Search: "Rechercher",
  search: "rechercher",
  "Sale order": "Bon de commande",
  Debt: "Dette",
  "Debt refund": "Remboursement de dette",
  "Stock transfer": "Transfert de stock",
  "Fund transfer": "Transfert de fonds",
  "Return to supplier": "Retour au fournisseur",
  Customer: "Client",
  customer: "client",
  "Total Incomes": "Total des revenus",
  "total incomes": "total des revenus",
  "Top account": "Meilleur compte",
  "Top category": "Meilleure catégorie",
  "Total Incomes stats": "Statistiques des revenus totaux",
};
